<template>
  <div>
    <!-- 假设您的 Vue 组件中有一个按钮，用于触发添加商品到购物车的操作 -->
    <button @click="addToCart">Add to Cart</button>
  </div>
</template>

<script>
// 获取 URL 中的查询参数，并解析成对象
function getQueryParams(url) {
  const params = new URL(url).searchParams;
  let res = Object.fromEntries(params);
  // console.log(res)
}

getQueryParams(window.location.href)

import axios from 'axios';

export default {
  methods: {
    async addToCart() {
      const variantId = '45597615718699'; // 假设您已经获取到了商品变体的 ID
      const quantity = 1; // 假设要添加的商品数量是1

      // 使用 Storefront API 的 checkoutCreate mutation 创建购物车
      const cartId = await this.createCart();

      // 使用 Storefront API 的 checkoutLineItemsAdd mutation 将商品添加到购物车
      await this.addLineItemToCart(cartId, variantId, quantity);

      // 构建 Shopify 商城 URL，并将购物车 ID 作为参数传递
      const shopifyUrl = `https://cobetter-4573.myshopify.com/cart/${cartId}`;

      // 跳转到 Shopify 商城
      window.location.href = shopifyUrl;
    },
    async createCart() {
      const response = await axios.post(
        'https://cobetter-4573.myshopify.com/api/2023-07/graphql',
        {
          query: `
            mutation {
              checkoutCreate(input: {}) {
                checkout {
                  id
                }
              }
            }
          `,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': 'aa650fdcff1ad83c009c22714bc9164e',
          },
        }
      );
      console.log('createCart');
      console.log(response);
      return response.data.data.checkoutCreate.checkout.id;
    },
    async addLineItemToCart(cartId, variantId, quantity) {
      const response = await axios.post(
        'https://cobetter-4573.myshopify.com/api/2023-07/graphql',
        {
          query: `
            mutation {
              checkoutLineItemsAdd(
                lineItems: [{ variantId: "${variantId}", quantity: ${quantity} }]
                checkoutId: "${cartId}"
              ) {
                checkout {
                  id
                }
              }
            }
          `,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': 'aa650fdcff1ad83c009c22714bc9164e',
          },
        }
      );
      console.log('addLineItemToCart');
      console.log(response)
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/test.vue